import {
  ComparisonOp,
  LogicalOp,
  TimeRangeOp,
} from '@/proto/logiblocks/logiblocks';

/**
 * Display labels and other metadata for enums used throughout Logiblocks.
 * Add new enum mappings here as they are needed; not limited to proto enums.
 */

export const COMPARISON_OP_LABELS: Record<ComparisonOp, string> = {
  // Universal
  [ComparisonOp.COMPARISON_EQUALS]: 'Equals',
  [ComparisonOp.COMPARISON_NOT_EQUALS]: 'Not Equals',
  [ComparisonOp.COMPARISON_EXISTS]: 'Exists',
  [ComparisonOp.COMPARISON_NOT_EXISTS]: 'Does Not Exist',
  // Text
  [ComparisonOp.COMPARISON_CONTAINS]: 'Contains',
  [ComparisonOp.COMPARISON_NOT_CONTAINS]: 'Does Not Contain',
  [ComparisonOp.COMPARISON_STARTS_WITH]: 'Starts With',
  [ComparisonOp.COMPARISON_ENDS_WITH]: 'Ends With',
  [ComparisonOp.COMPARISON_IS_EMPTY]: 'Is Empty',
  [ComparisonOp.COMPARISON_IS_NOT_EMPTY]: 'Is Not Empty',
  [ComparisonOp.COMPARISON_REGEX_MATCHES]: 'Matches Regex',
  // Numeric
  [ComparisonOp.COMPARISON_GREATER_THAN]: 'Greater Than',
  [ComparisonOp.COMPARISON_GREATER_THAN_OR_EQUAL]: 'Greater Than or Equal',
  [ComparisonOp.COMPARISON_LESS_THAN]: 'Less Than',
  [ComparisonOp.COMPARISON_LESS_THAN_OR_EQUAL]: 'Less Than or Equal',
  [ComparisonOp.COMPARISON_BETWEEN]: 'Between',
  [ComparisonOp.COMPARISON_NOT_BETWEEN]: 'Not Between',
  // List
  [ComparisonOp.COMPARISON_IN_LIST]: 'In List',
  [ComparisonOp.COMPARISON_NOT_IN_LIST]: 'Not In List',
  // Boolean
  [ComparisonOp.COMPARISON_IS_TRUE]: 'Is True',
  [ComparisonOp.COMPARISON_IS_FALSE]: 'Is False',
  // Datetime ordering
  [ComparisonOp.COMPARISON_BEFORE]: 'Before',
  [ComparisonOp.COMPARISON_ON_OR_BEFORE]: 'On or Before',
  [ComparisonOp.COMPARISON_AFTER]: 'After',
  [ComparisonOp.COMPARISON_ON_OR_AFTER]: 'On or After',
  [ComparisonOp.UNRECOGNIZED]: 'Unknown',
};

export const LOGICAL_OP_LABELS: Record<LogicalOp, string> = {
  [LogicalOp.AND]: 'and',
  [LogicalOp.OR]: 'or',
  [LogicalOp.UNRECOGNIZED]: 'Unknown',
};

export const TIME_RANGE_OP_LABELS: Record<TimeRangeOp, string> = {
  [TimeRangeOp.WITHIN]: 'Within',
  [TimeRangeOp.NOT_WITHIN]: 'Not within',
  [TimeRangeOp.UNRECOGNIZED]: 'Unknown',
};
